import './receptions/style';
import FormStructure from './receptions/form_structure';

export default FormStructure;